import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { PartnerDto, PartnersRycApiClient } from '../../Api/ApiServer';
import { Inbox, Drafts, Business, Delete, Edit, ArrowBack, Save, Add, Hail } from '@mui/icons-material';
import DeleteDialog from '../../Shared/DeleteDialog';
import { useApi } from '../../Api/useApi';
import PartnerDetail, { PartnerDetailRef } from './PartnerDetail';

export interface PartnerSelectDetailDialogProps {
    onClose: () => void;
    open: boolean;
    partners: PartnerDto[];
    onSelect: (partner: PartnerDto) => void;
    onRefresh?: () => void;
}
export default function PartnerSelectDetailDialog(props: PartnerSelectDetailDialogProps, ref: any) {
    const { onClose, open, partners, onSelect, onRefresh } = props;
    const [deletingPartner, setDeletingPartner] = React.useState<PartnerDto | null>(null);
    const [selectedPartner, setSelectedPartner] = React.useState<PartnerDto | null>(null);

    const { authorizedApi } = useApi(PartnersRycApiClient);

    useEffect(() => {
        if (open) {
            setSelectedPartner(null);
        }
    }, [open]);

    // const [open, setOpen] = React.useState(false);
    const handleClose = () => {
        onClose();
    };
    
    const partnerDetailRef = useRef<PartnerDetailRef>(null);

    return (
        <Dialog
            open={open}
            fullWidth
            onClose={() => { handleClose() }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {selectedPartner === null && <Grid2 size={{ xs: 12 }} display={'flex'} alignItems={'center'}>
                        <Typography variant="h5" gutterBottom sx={{ flexGrow: 1, mt: 1 }}>
                          {'Seznam partnerů'}
                        </Typography>
                        <IconButton onClick={() => setSelectedPartner(new PartnerDto())}>
                            <Add />
                        </IconButton>
                    </Grid2>}
                {selectedPartner !== null && <Grid2 size={{ xs: 12 }} display={'flex'} alignItems={'center'}>
                        <IconButton onClick={() => setSelectedPartner(null)}>
                            <ArrowBack />
                        </IconButton>
                        <Typography variant="h5" gutterBottom sx={{ flexGrow: 1, mt: 1 }}>
                            {'Detail partnera'}
                        </Typography>
                        <IconButton onClick={() => partnerDetailRef.current?.onSavePartner()}>
                            <Save />
                        </IconButton>
                      </Grid2>}
            </DialogTitle>
            <DialogContent dividers sx={{ maxHeight: "60vh", overflowY: "auto", display: "flex", flexDirection: "column" }}>
                {selectedPartner === null && <List>
                    {partners.map((partner, index) => (
                        <ListItem key={index} component="div" sx={{ cursor: "pointer" }} onClick={() => onSelect(partner)}>
                            <ListItemIcon sx={{ flexShrink: 0 }}>
                               {partner.isCompany && <Business />}
                               {!partner.isCompany && <Hail />}
                            </ListItemIcon>
                            <ListItemText primary={partner.name} sx={{ flex: 1 }} />
                            <ListItemText primary={partner.ico} />
                            <IconButton onClick={(e) => {e.preventDefault(); e.stopPropagation(); setSelectedPartner(partner); }} sx={{ flexShrink: 0, minWidth: "auto", padding: 0 }}>
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: 40, height: 40 }}>
                                    <Edit />
                                </Box>
                            </IconButton>
                            <IconButton onClick={(e) => {e.preventDefault(); e.stopPropagation(); setDeletingPartner(partner)}} sx={{ flexShrink: 0, minWidth: "auto", padding: 0 }}>
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: 40, height: 40 }}>
                                    <Delete />
                                </Box>
                            </IconButton>
                        </ListItem>
                    ))}
                </List>}
                {selectedPartner !== null && <PartnerDetail ref={partnerDetailRef} partner={selectedPartner} onSaved={() => {setSelectedPartner(null); if (onRefresh) onRefresh(); }} />}
                <DeleteDialog open={deletingPartner !== null} data={deletingPartner} onClose={() => { setDeletingPartner(null)}} onDeleteAgree={(data) => {  
                    setDeletingPartner(null);                  
                    authorizedApi?.deletePartner(data.id).then(() => {
                        if (onRefresh) {
                            onRefresh();
                        }
                    })}} />
            </DialogContent>
            <DialogActions>
               {/*  <Button onClick={() => { handleClose() }} autoFocus>
                    {'OK'}
                </Button> */}
                <Button onClick={() => { handleClose() }} autoFocus>
                    {'ZAVŘÍT'}
                </Button>
            </DialogActions>
        </Dialog>);
}